import React, { useEffect } from "react";

import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import editor from "../../Assets/Projects/codeEditor.jpg";
import bitsOfCode from "../../Assets/Projects/blog.jpg";
import gram from  '../../Assets/Projects/gram.jpg'
import hamroh from '../../Assets/Projects/hamroh.jpg'
import AOS from "aos";
import "aos/dist/aos.css";

function Projects() {
  useEffect(() => {
    AOS.init({
      duration: 3000,
    });
  }, []);

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}
         >
          <Col md={4} className="project-card" data-aos="fade-up">
            <ProjectCard
              imgPath={gram}
              isBlog={false}
              title="Gram"
              description="Gram is a national company developing innovative applications in the field of logistics and transport."
              ghLink="https://github.com/SabrinaOnly"
              demoLink="https://www.gram.tj/TJ/khujand/ru"
            />
          </Col>

          <Col md={4} className="project-card" data-aos="fade-up">
            <ProjectCard
             imgPath={editor}
              isBlog={false}
              title="Weather App"
              description="My weather app,in order for you to be able to use the application, please search for your country and the application itself will find your region and display the weather"
              ghLink="https://github.com/SabrinaOnly/vue-weaher-app"
              demoLink="https://unique-monstera-0bb842.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card" data-aos="fade-up">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Online Store"
              description="A website that sells goods via the Internet. Allows users online, in their browser or through a mobile application, to create a purchase order, select a method of payment and delivery of the order, and pay for the order. At the same time, the sale of goods is carried out remotely and it imposes restrictions on the goods sold."
              ghLink="https://github.com/SabrinaOnly/react-store"
              demoLink="https://merry-donut-8ec6b7.netlify.app/"              
            />
          </Col>

          <Col md={4} className="project-card" data-aos="fade-up">
            <ProjectCard
              imgPath={hamroh}
              isBlog={false}
              title="Hamroh Gram Trip"
              description="Used the plant disease dataset from Kaggle and trained a image classifer model using 'PyTorch' framework using CNN and Transfer Learning with 38 classes of various plant leaves. The model was successfully able to detect diseased and healthy leaves of 14 unique plants. I was able to achieve an accuracy of 98% by using Resnet34 pretrained model."
              demoLink="https://hamroh.gram.tj/passTrip"
              ghLink="https://github.com/SabrinaOnly"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
